import React, {Suspense} from 'react'
import useQueryLoaderNow from '../../../../hooks/useQueryLoaderNow'
import useRouter from '../../../../hooks/useRouter'
import newTeamQuery, {} from '../../../../__generated__/NewTeamQuery.graphql'
import NewTeam from '../../NewTeam'

const NewTeamRoot = () => {
  const {match} = useRouter()
  const {params} = match
  const {defaultOrgId} = params
  const queryRef = useQueryLoaderNow(newTeamQuery)
  return (
    React.createElement(Suspense, { fallback: '',}
      , queryRef && React.createElement(NewTeam, { queryRef: queryRef, defaultOrgId: defaultOrgId,} )
    )
  )
}

export default NewTeamRoot
